export default __webpack_public_path__ + "static/media/teacher_testimony_one.ea48bdef.png";